module.exports = __webpack_public_path__ + "static/media/overMij.d52db63e.jpg";